var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgImg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 11,
    viewBox: "0 0 17 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.5709 6.13981L12.3456 10.365C11.9495 10.7942 11.2563 10.7942 10.8602 10.365C10.4311 9.96893 10.4311 9.27573 10.8602 8.87961L13.2699 6.43689H1.05631C0.462136 6.43689 0 5.97476 0 5.38058C0 4.7534 0.462136 4.32427 1.05631 4.32427H13.2699L10.8602 1.91456C10.4311 1.51845 10.4311 0.825243 10.8602 0.429126C11.2563 0 11.9495 0 12.3456 0.429126L16.5709 4.65437C17 5.05049 17 5.74369 16.5709 6.13981Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImg);
export default __webpack_public_path__ + "static/media/img_.3225c889a0dcafffbbef914a45002fa0.svg";
export { ForwardRef as ReactComponent };